import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import {getToken, setToken} from "chaos-sso-util";
import {isFrame, jumpHandler} from "./utils/other";

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axios=axios
Vue.prototype.$Message=ElementUI.Message
Vue.prototype.$center=new Vue()
/*iframe 嵌套逻辑*/
if (isFrame()) {

  window.parent.postMessage('skillMapIframeReady', '*')
  window.addEventListener('message', (e) => {
    try {
      let data = JSON.parse(e.data)
      let _userId = data.potalUserId
      let token = getToken()
      if (!token) {
        setToken(data.potalToken)
      }
      if (_userId && token) {
        jumpHandler({ userId: _userId, router })
      }
    } catch (e) {}
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js